const maxCenterWidth = 290;
const minPeek = 42;

function scrollToReviews() {
  const target = document.querySelector('[data-bv-show="reviews"]');
  if (!target) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  $s.scrollToElement(target, 0, reduceMotion ? 'auto' : 'smooth');
  if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });
}

function fitCarousel(carousel) {
  const gap = parseFloat(carousel.dataset.carouselSpacingMobile) || 0;
  const mobileOnly = window.matchMedia(carousel.dataset.mobileQuery);

  function fit() {
    // the carousel shares its loop and centered flags between tablet and mobile, so only enable them on mobile
    if (mobileOnly.matches) {
      const viewportWidth = document.documentElement.clientWidth;
      // keep at least minPeek of the neighbors visible; shrink the card if the screen is too narrow
      const centerWidth = Math.min(maxCenterWidth, viewportWidth - minPeek * 2);
      carousel.closest('.fr-container').style.setProperty('--fr-center-width', centerWidth + 'px');
      carousel.slidesPerViewMobile = ((viewportWidth + gap) / (centerWidth + gap)).toFixed(3);
      carousel.carouselCenteredMobile = 'true';
      carousel.carouselLoopMobile = carousel.dataset.mobileLoop;
    } else {
      carousel.carouselCenteredMobile = 'false';
      carousel.carouselLoopMobile = 'false';
    }
    if (carousel.sliderObj) carousel.reset();
  }

  $s.resizeWidthHandle(fit);
}

function initFeaturedReviews() {
  document.querySelectorAll('.fr-carousel:not([data-fr-bound])').forEach((carousel) => {
    carousel.dataset.frBound = 'true';
    fitCarousel(carousel);
  });
  document.querySelectorAll('.fr-button:not([data-fr-bound])').forEach((button) => {
    button.dataset.frBound = 'true';
    button.addEventListener('click', scrollToReviews);
  });
}

initFeaturedReviews();
document.addEventListener('shopify:section:load', initFeaturedReviews);
